import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { LogTag } from 'components';

import { LogTagType } from 'components/tags/LogTag';
import { IHistoryListItemProps } from './HistoryListItem.types';

import './HistoryListItem.styles.scss';

const { Text } = Typography;

const HistoryListItem = ({
  field,
  newValues,
  oldValues,
  renderPrefix,
  className = '',
  ...props
}: IHistoryListItemProps) => {
  const { t } = useTranslation();

  const values = newValues.length > oldValues.length ? newValues : oldValues;

  return (
    <div className={`np-history-list-item ${className}`} {...props}>
      <Row gutter={8} align="top">
        <Col className="np-history-list-item__field">
          <Text strong>{t(field)}:</Text>
        </Col>

        <Col className="np-history-list-item__changes">
          {values.map((_, index) => {
            const prefix = renderPrefix(index);

            return (
              <Row gutter={[8, 8]} key={index}>
                {prefix && (
                  <Col className="np-history-list-item__field">
                    <Text strong>{typeof prefix === 'string' ? t(prefix) : prefix}:</Text>
                  </Col>
                )}

                {oldValues?.[index] && (
                  <Col className="np-history-list-item__old">
                    <LogTag value={oldValues[index]} type={LogTagType.OLD} />
                  </Col>
                )}

                {newValues?.[index] && (
                  <Col className="np-history-list-item__new">
                    <LogTag value={newValues?.[index]} type={LogTagType.NEW} />
                  </Col>
                )}
              </Row>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

export default HistoryListItem;
